export const typeColors: { [key: string]: string } = {
  bug: "#91A119",
  dark: "#50413F",
  dragon: "#5061E1",
  electric: "#FAC000",
  fairy: "#F170F1",
  fighting: "#C03028",
  fire: "#E62829",
  flying: "#81B9EF",
  ghost: "#704170",
  grass: "#42A129",
  ground: "#915121",
  ice: "#3FD8FF",
  normal: "#9FA19F",
  poison: "#9040CC",
  psychic: "#F14179",
  rock: "#AFA981",
  steel: "#60A1B8",
  water: "#2980EF",
};
